export default [
    {
        name: 'picks.mine',
        path: '/picks/me',
        component: () => import("@/views/modules/picking/pages/my-picks/List.vue")
    },
    {
        name: 'picks.all',
        path: '/picks',
        component: () => import("@/views/modules/picking/pages/all-picks/List.vue")
    },
    {
        name: 'picks.pick',
        path: '/picks/:id',
        component: () => import("@/views/modules/picking/pages/pick/ListItems.vue"),
    }
]
